import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	noOverviews: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-overviews.common.empty-state.no-overviews',
		defaultMessage: "Once you create an overview, it'll show up here.",
		description: 'Message for the empty state in the sidebar overviews expandable menu',
	},
});
